import { Header, Identity as IdentityComponent } from "components"
export const Identity = () => {
 return (
  <>
   <Header />
   <IdentityComponent />
  </>
 )
}
